var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "item_fancafe",
        attrs: { href: _vm.cafeUrl, target: "_blank" },
      },
      [
        _c("span", { staticClass: "num_item" }, [
          _vm._v("\n            " + _vm._s(_vm.currRank) + "\n            "),
          _vm.rankDiff > 0
            ? _c("span", { staticClass: "info_change type_up" }, [
                _c("span", { staticClass: "ico_cafetop ico_up" }, [
                  _vm._v("상승"),
                ]),
                _vm._v(_vm._s(_vm.rankDiff)),
              ])
            : _vm.rankDiff < 0
            ? _c("span", { staticClass: "info_change" }, [
                _c("span", { staticClass: "ico_cafetop ico_down" }, [
                  _vm._v("하락"),
                ]),
                _vm._v(_vm._s(Math.abs(_vm.rankDiff))),
              ])
            : _c("span", { staticClass: "info_change" }, [
                _c("span", { staticClass: "ico_cafetop ico_stay" }, [
                  _vm._v("유지"),
                ]),
              ]),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fancafe_link" }, [
          _c("div", { staticClass: "thumb_g" }, [
            _c("img", {
              attrs: {
                src: _vm.profileImageUrl,
                width: "70",
                height: "70",
                alt: "",
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _vm.tab === "fandom"
          ? _c("div", { staticClass: "box_item" }, [
              _c("strong", { staticClass: "tit_item" }, [
                _c("span", [_vm._v(_vm._s(_vm.starName))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc_item" }, [
                _c("ul", { staticClass: "list_data" }, [
                  _c("li", { staticClass: "txt_cafe" }, [
                    _vm._v("카페 "),
                    _c("em", [_vm._v(_vm._s(_vm.cafeCurrRank) + "등")]),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "txt_cheer" }, [
                    _vm._v("응원 "),
                    _c("em", [_vm._v(_vm._s(_vm.cheerCurrRank) + "등")]),
                  ]),
                ]),
              ]),
            ])
          : _vm.tab === "cafe"
          ? _c("div", { staticClass: "box_item" }, [
              _c("strong", { staticClass: "tit_item" }, [
                _c("span", [_vm._v(_vm._s(_vm.starName))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "desc_item" }, [
                _c("ul", { staticClass: "list_data" }, [
                  _c("li", [
                    _vm._v("방문 "),
                    _c("em", [_vm._v(_vm._s(_vm.visitScore.toLocaleString()))]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("가입 "),
                    _c("em", [_vm._v(_vm._s(_vm.newMemberScore))]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v("새글 "),
                    _c("em", [_vm._v(_vm._s(_vm.newArticleScore))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "list_info" }, [
                  _vm.manage ? _c("li", [_vm._v("소속사")]) : _vm._e(),
                  _vm._v(" "),
                  _vm.starJoin ? _c("li", [_vm._v("스타가입")]) : _vm._e(),
                ]),
              ]),
            ])
          : _vm.tab === "cheer"
          ? _c("div", { staticClass: "box_item" }, [
              _c("strong", { staticClass: "tit_item" }, [
                _c("span", [_vm._v(_vm._s(_vm.starName))]),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "info_cheer" }, [
                _vm._v("응원 "),
                _c("em", [
                  _vm._v(_vm._s(_vm.cheerScore.toLocaleString()) + "점"),
                ]),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }